import { useAuth } from "@/contexts/AuthContext";
import { useUserSync } from "@/hooks/useUserSync";
import { useToast } from "./ui/use-toast";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const UserNav = () => {
  const { user, logout } = useAuth();
  const { userData } = useUserSync();
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      toast({
        title: "Logged out successfully",
        description: "Come back soon!",
      });
      navigate('/');
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Error logging out",
        description: "Please try again",
      });
    }
  };

  if (!user) return null;

  return (
    <div className="flex items-center gap-4">
      {userData?.isPremium && (
        <span className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-sm font-medium border border-purple-200">
          Premium User
        </span>
      )}
      
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button 
            variant="ghost" 
            className="flex items-center gap-2 hover:bg-gray-100"
          >
            <img 
              src={user.photoURL || `https://ui-avatars.com/api/?name=${user.email}`}
              alt="Profile" 
              className="w-8 h-8 rounded-full border-2 border-gray-200"
            />
            <div className="flex flex-col items-start">
              <span className="text-sm font-medium">
                {user.displayName || user.email?.split('@')[0]}
              </span>
              <span className="text-xs text-gray-500">
                {user.email}
              </span>
            </div>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuLabel>My Account</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            onClick={handleLogout}
            className="text-red-600 cursor-pointer"
          >
            <span>Log out</span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}; 